import React, { Component } from 'react';
import * as util from '../../../utils/EnumMapping';
import MainTable from '../../common/table/MainTable';
import * as columns from './CloseColumns';

class Close extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CLOSE";
            item.closeObjectTypeLabel = util.getLabel(util.objectTypes, item.closeObjectType);
            item.closeTypeLabel = util.getLabel(util.closeTypes, item.closeType);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="link"
                tableName="Lezárások"
                path='/api/manualclose/list'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                needAggregate={false}
            />
        );
    }
}

export default Close;
